module.exports = __webpack_public_path__ + "static/media/Farma pasa . Autocenzura (Poruka u boci).9a5ba26d.mp3";